// import { Component } from "@angular/core";

// @Component({
//   selector: "app-root",
//   templateUrl: "./app.component.html",
//   styleUrls: ["./app.component.css"],
// })
// export class AppComponent {
//   title = "gm-customer-portal";
// }

import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
// assets/scripts/main.d810cf0ae7f39f28f336.js
// import {  } from '../assets/scripts/main.d810cf0ae7f39f28f336.js';

import { IdleService } from "./services/idle/idle.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "gm-customer-portal";
  constructor(private router: Router,private authService: AuthenticationService, private idleService: IdleService) {}
  ngOnInit() {
    this.checkUserStatus();
    if (localStorage.getItem("customerId") == null) {
      this.router.navigate(["/login"]);
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Load your script here
        this.loadScript("../assets/scripts/main.d810cf0ae7f39f28f336.js");
      }
    });
  }

  private loadScript(scriptUrl: string) {
    const script = document.createElement("script");
    script.src = scriptUrl;
    document.body.appendChild(script);
  }

  checkUserStatus(){
      this.authService.onReloadUserStatusCheck();
  }
}
